import { useEffect, useState } from "react";
import { useCachedGet, memInvalidate } from "@/lib/dataCache";

export function useLeadSettings() {
  const { data, reload } = useCachedGet("/lead-settings", { ttlMs: 60_000 });
  const s = data && data.statuses ? data : null;
  const statusMap = Object.fromEntries((s?.statuses || []).map((x) => [x.key, x]));
  return { settings: s, statusMap, reload: () => { memInvalidate("/lead-settings"); return reload(); } };
}

export function useNow(ms = 30_000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}

export function statusStyle(color) {
  const c = color || "#737373";
  return { color: c, backgroundColor: `${c}1f`, borderColor: `${c}55` };
}

export function scoreTone(score) {
  if (score == null) return "bg-muted text-muted-foreground border-border";
  if (score >= 8) return "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/40";
  if (score >= 5) return "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/40";
  return "bg-rose-500/15 text-rose-700 dark:text-rose-300 border-rose-500/40";
}

export function wordCount(s) {
  return (s || "").trim().split(/\s+/).filter(Boolean).length;
}

export function toLocalInput(d) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function relTime(iso, now = Date.now()) {
  if (!iso) return "—";
  const diff = new Date(iso).getTime() - now;
  const abs = Math.abs(diff);
  const m = Math.round(abs / 60000);
  if (m < 1) return "just now";
  let txt;
  if (m < 60) txt = `${m}m`;
  else if (m < 60 * 24) txt = `${Math.round(m / 60)}h`;
  else txt = `${Math.round(m / 1440)}d`;
  return diff >= 0 ? `in ${txt}` : `${txt} ago`;
}

export function fmtDuration(ms) {
  const m = Math.floor(Math.abs(ms) / 60000);
  if (m < 60) return `${m}m`;
  if (m < 1440) return `${Math.floor(m / 60)}h ${m % 60}m`;
  return `${Math.floor(m / 1440)}d`;
}

export function fmtShort(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true });
}
